/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mCountUp.vue?vue&type=template&id=448d9baf&scoped=true"
import script from "./mCountUp.vue?vue&type=script&lang=js"
export * from "./mCountUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d9baf",
  null
  
)

export default component.exports